import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  createFolder,
  fetchFolder,
  updateFolder,
} from '../../actions/studio/folders';
import { getIsBusy } from '../../selectors/studio/folders';
import { AppState } from '../../types/store';
import { Props } from './FolderModal';
import { getFeaturedFolderId, getSelectedFolder } from '../../selectors/studio';

export type StateProps = Pick<
  Props,
  'isBusy' | 'coreLevel' | 'selectedFolder' | 'featuredFolderId'
>;
export type DispatchProps = Pick<Props, 'saveFolder' | 'fetchFolder'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isBusy: getIsBusy(state),
  coreLevel: getCoreLevel(state),
  selectedFolder: getSelectedFolder(state),
  featuredFolderId: getFeaturedFolderId(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { folderId, folderType }
) => ({
  fetchFolder: onFetchSuccess =>
    dispatch(fetchFolder(folderId!, folderType, onFetchSuccess)),
  saveFolder: (data, onSaveSuccess) =>
    folderId
      ? dispatch(updateFolder({ folderId, data, onSaveSuccess }))
      : dispatch(createFolder(data, onSaveSuccess)),
});

export default connect(mapStateToProps, mapDispatchToProps);
